module.exports = __webpack_public_path__ + "img/IMG-3391.4f9f6bb4.jpg";